// extracted by mini-css-extract-plugin
export var card = "_mb-1";
export var summary = "_mb-0";